export const USER_STATUS: any = {
  ACTIVE: "--active",
  BLOCKED: "--block",
  PENDING_UPDATE: "--pending",
  NOT_FOUND: "--not-found",
  DELETED: "--not-found",
  INACTIVE: "--inactive",
};
